import type { RouteData } from 'src/shared/app/base/route/type/routeTypes';
import { getRoutePath } from 'src/shared/app/base/route/util/routeUtils';

export default function useRoute(route?: RouteData): string | null {
  return route ? getRoutePath(route) : null;
}
